import React from 'react';
import { getCurrentUserHashedEmail } from '../../../utils/auth/authenticatedUser';
import { getPublicClientConfig } from '../../../services/truststartService';
import Text from '../../../components/Text';
import { EmbeddableConfigContext } from '../../../config/EmbeddableContext';
import { LanguageConsumer } from '../../../config/LanguageContext';
import { FLINKS_DEMO } from '../../../config/configuration';
import { generateFlinksIframeURL } from '../../../config/bankingTypes';
import SITE_PATHS from '../../../config/sitePaths';
import Loader from '../../../components/Loader';
import IFrame from './FlinksConnect.iframe';
import { SkipBankingButtonWithoutState as SkipBankingButton } from '../SkipBankingButton';
import ErrorMessage from './FlinksConnect.errorMessage';

import '../Banking.scss';

export default class FlinksConnectContainer extends React.Component {
  thankYouPageURL = escape(`${window.location.origin}/thank-you.html?contentonly=true&willRedirect=true`);

  constructor(props) {
    super(props);
    this.state = {
      config: null,
      showSkipButton: false,
      loading: true,
      hashedUserEmail: null,
      instituteSelected: false,
      showSkipBankingSurvey: false,
    };
  }

  async componentDidMount() {
    const [hashedUserEmail, config] = await Promise.all([
      getCurrentUserHashedEmail(),
      getPublicClientConfig(this.props.clientId),
    ]);
    this.setState({ hashedUserEmail, config });
  }

  handleSkipBankingSurveyClosed = (didSkip) => {
    this.setState({ showSkipBankingSurvey: false });
    if (didSkip) this.props.onNextStep();
  };

  createFlinksIFrame(language, isRedirectedFromStandalone) {
    const {
      loading,
      hashedUserEmail,
    } = this.state;

    const { banking, url: connectURL } = this.state.config;

    const { redirectUrl: clientRedirectURL } = banking;

    let useUSBankingWorkflow = false;
    const skipConsent = !!this.props.isSmartSelect;

    useUSBankingWorkflow = banking.region?.toLowerCase() === 'us';

    const url = generateFlinksIframeURL(
      connectURL,
      this.props.requestId,
      this.thankYouPageURL,
      FLINKS_DEMO,
      useUSBankingWorkflow,
      language,
      this.props.webhookData,
      skipConsent,
      this.props.bankId,
    );

    return (
      <IFrame
        url={url}
        clientId={this.props.clientId}
        requestId={this.props.requestId}
        createScoringRequest={this.props.createScoringRequest}
        clientRedirectURL={clientRedirectURL}
        isRedirectedFromStandalone={isRedirectedFromStandalone}
        onNextStep={this.props.onNextStep}
        loading={loading}
        hashedUserEmail={hashedUserEmail}
        toggleSkipButton={(visible) => {
          if (!isRedirectedFromStandalone) this.setState({ showSkipButton: visible });
        }}
        hideLoader={() => {
          this.setState({ showSkipButton: !isRedirectedFromStandalone, loading: false });
          if (this.props.showBackButton) this.props.showBackButton();
        }}
        onError={this.props.onError}
        preventRedirectToSocial={this.props.preventRedirectToSocial}
        onInstitutionSelected={() => this.setState({ instituteSelected: true })}
      />
    );
  }

  render() {
    return (
      <EmbeddableConfigContext.Consumer>
        {(embeddedContext) => {
          const {
            hashedUserEmail,
            loading,
            showSkipButton,
            config,
          } = this.state;

          const { enabledFeatures } = embeddedContext;
          if (enabledFeatures.tswebEnabled && !enabledFeatures.tswebBanking) {
            this.props.history.push(SITE_PATHS.SOCIAL_CONNECTORS, { isEmbedded: true });
            return null;
          }

          const bankingProvider = config?.banking.provider || config?.banking.newProvider;

          return (
            <LanguageConsumer>
              {({ language }) => {
                if (!hashedUserEmail) return <Loader />;
                if (!config) {
                  return <ErrorMessage showSkipMessage={false} language={language} />;
                }
                if (!bankingProvider) {
                  return (
                    <>
                      <ErrorMessage showSkipMessage language={language} />
                      {!this.props.hideSkipButton && (
                        <SkipBankingButton
                          clientId={this.props.clientId}
                          requestId={this.props.requestId}
                          showButton
                          skipBankingSurvey={this.props.skipBankingSurvey}
                          onSkipBanking={this.handleSkipBankingSurveyClosed}
                          isOpen={this.state.showSkipBankingSurvey}
                          onSkipButtonClick={() => this.setState({ showSkipBankingSurvey: true })}
                        />
                      )}
                    </>
                  );
                }

                return (
                  <div className="thank-you-screen">
                    {loading ? <Loader /> : null}
                    {
                      !loading && !this.state.instituteSelected && !this.props.isSmartSelect
                      && (
                        <h4 data-cy="helpText">
                          <Text value="Please select your bank to start the verification process:" />
                        </h4>
                      )
                    }
                    {
                      this.createFlinksIFrame(
                        language,
                        enabledFeatures.tswebEnabled && enabledFeatures.tswebBanking,
                      )
                    }
                    {!this.props.hideSkipButton && (
                      <SkipBankingButton
                        clientId={this.props.clientId}
                        requestId={this.props.requestId}
                        showButton={showSkipButton}
                        skipBankingSurvey={this.props.skipBankingSurvey}
                        onSkipBanking={this.handleSkipBankingSurveyClosed}
                        isOpen={this.state.showSkipBankingSurvey}
                        onSkipButtonClick={() => this.setState({ showSkipBankingSurvey: true })}
                      />
                    )}
                  </div>
                );
              }}
            </LanguageConsumer>
          );
        }}
      </EmbeddableConfigContext.Consumer>
    );
  }
}
